<template>
    <v-container fluid>
        <v-sheet
                v-if="!trimestralLoaded"
                :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                class="px-3 pt-3 pb-3">
            <v-row dense>
                <v-col cols="3">
                    <v-skeleton-loader
                            class="mx-auto"
                            max-width="300"
                            type="card"/>
                </v-col>
                <v-col cols="3">
                    <v-skeleton-loader
                            class="mx-auto"
                            max-width="300"
                            type="card"/>
                </v-col>
                <v-col cols="3">
                    <v-skeleton-loader
                            class="mx-auto"
                            max-width="300"
                            type="card"/>
                </v-col>
                <v-col cols="3">
                    <v-skeleton-loader
                            class="mx-auto"
                            max-width="300"
                            type="card"/>
                </v-col>
            </v-row>
        </v-sheet>
        <v-row dense>
            <v-col cols="11" style="margin:0 2em 0 2em">
                <v-card :loading="!loaded">
                    <v-card-title>
                        {{client.socialName}}
                    </v-card-title>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12"
                                       md="6">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            label="Nombre Fiscal"
                                            v-model="client.fiscalName"
                                            :readonly=true
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12"
                                       md="6">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            :readonly=true
                                            label="CIF"
                                            v-model="client.CIF"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            label="Email"
                                            v-model="client.email"
                                            :readonly=true
                                    ></v-text-field>
                                </v-col>
                              <v-col cols="12" md="4" v-if="client.phone!==null">
                                <v-text-field
                                    color="rgba(0, 0, 0, 0.65)"
                                    label="Phone"
                                    v-model="client.phone"
                                    :readonly=true
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="4" v-if="client.web!==null">
                                <v-text-field
                                    color="rgba(0, 0, 0, 0.65)"
                                    label="Web"
                                    v-model="client.web"
                                    :readonly=true
                                ></v-text-field>
                              </v-col>
                                <v-col cols="12"
                                       md="4">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            label="Dirección"
                                            v-model="client.address"
                                            :readonly=true
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12"
                                       md="3">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            :readonly=true
                                            label="Población"
                                            v-model="client.town"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            label="Provincia"
                                            v-model="client.province"
                                            :readonly=true
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field
                                            color="rgba(0, 0, 0, 0.65)"
                                            label="Código Postal"
                                            v-model="client.postalCode"
                                            :readonly=true
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <v-tabs
                            v-model="tab"
                            class="elevation-2"
                            :centered=true>
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab v-for="i in tabs" :key="i.id" :href="`#tab-${i.id}`">
                            {{ i.title }}
                        </v-tab>
                        <v-tab-item value="tab-1">
                            <v-card-title>Facturas de cliente</v-card-title>
                            <invoices-table :invoices="invoices" :refresh="getData"/>
                        </v-tab-item>
                        <v-tab-item value="tab-2">
                            <v-card-title>Presupuestos de cliente</v-card-title>
                            <budgets-table :budgets="budgets" :refresh="getData"/>
                        </v-tab-item>
                        <v-tab-item value="tab-3">
                            <v-card-title>
                                Resumen Anual {{year}}
                                <v-spacer></v-spacer>
                                <v-select
                                        v-model="year"
                                        :items="items"
                                        label="Selecciona año"/>
                            </v-card-title>
                           <annual-table :first="first[0]" :second="second[0]" :third="third[0]" :fourth="fourth[0]" :total="total[0]"/>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import invoicesTable from "../components/client/invoicesTable";
    import budgetsTable from "../components/client/budgetsTable";
    import annualTable from "../components/client/annualTable";
    export default {
        name: "Clients",
        inject: ['theme'],
        components: {invoicesTable, budgetsTable,annualTable},
        data() {
            return {
                tab: null,
                tabs: [{'id': 1, 'title': 'Facturas'}, {'id': 2, 'title': 'Presupuestos'}, {'id': 3, 'title': 'Resumen Anual'}],
                year: new Date().getFullYear(),
                items:[2019,2020,2021],
                client: '',
                first: [],
                second: [],
                third: [],
                fourth: [],
                total:[],
                invoices: [],
                budgets: [],
                loaded: false,
                trimestralLoaded: false
            }
        },
        mounted() {
            this.getData();
            this.getTrimestral(new Date().getFullYear());
        },
        watch:{
            year:function (val) {
                this.getTrimestral(val)
            }
        },
        methods: {
            getData() {
                let url = this.base_url + '/invV2/admin/cliente/' + this.$route.params.id + '/' + localStorage.token;
                this.axios.get(url).then(response => {
                    this.client = response.data.client;
                    this.invoices = response.data.invoices;
                    this.budgets = response.data.projects;
                    this.loaded = true;
                });
            },
            getTrimestral(year) {
                this.trimestralLoaded = false;
                let trimestralUrl = this.base_url + '/invV2/admin/trimestrecliente/' + this.$route.params.id + '/' + year + '/' + localStorage.token;
               console.log(trimestralUrl)
                this.axios.get(trimestralUrl).then(response => {
                    this.first = response.data.first;
                    this.second = response.data.second;
                    this.third = response.data.third;
                    this.fourth = response.data.fourth;
                    this.total = response.data.total;
                    this.trimestralLoaded = true;
                });
            }
        }
    }
</script>

<style scoped>
    .clientLink {
        text-decoration: none;
        color: black;
        font-weight: bold;
    }
</style>